/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateTransferACHAddendaRecord,
  CreateTransferACHAddendaRecord$inboundSchema,
  CreateTransferACHAddendaRecord$Outbound,
  CreateTransferACHAddendaRecord$outboundSchema,
} from "./createtransferachaddendarecord.js";
import {
  DebitHoldPeriod,
  DebitHoldPeriod$inboundSchema,
  DebitHoldPeriod$outboundSchema,
} from "./debitholdperiod.js";
import {
  SECCode,
  SECCode$inboundSchema,
  SECCode$outboundSchema,
} from "./seccode.js";

export type CreateTransferSourceACH = {
  /**
   * An optional override of the default NACHA company entry description for a transfer.
   */
  companyEntryDescription?: string | undefined;
  /**
   * An optional override of the default NACHA company name for a transfer.
   */
  originatingCompanyName?: string | undefined;
  /**
   * An optional override of your default ACH hold period in banking days. The hold period must be longer than or equal to your default setting.
   */
  debitHoldPeriod?: DebitHoldPeriod | undefined;
  /**
   * Code used to identify the ACH authorization method.
   */
  secCode?: SECCode | undefined;
  addenda?: Array<CreateTransferACHAddendaRecord> | undefined;
};

/** @internal */
export const CreateTransferSourceACH$inboundSchema: z.ZodType<
  CreateTransferSourceACH,
  z.ZodTypeDef,
  unknown
> = z.object({
  companyEntryDescription: z.string().optional(),
  originatingCompanyName: z.string().optional(),
  debitHoldPeriod: DebitHoldPeriod$inboundSchema.optional(),
  secCode: SECCode$inboundSchema.optional(),
  addenda: z.array(CreateTransferACHAddendaRecord$inboundSchema).optional(),
});
/** @internal */
export type CreateTransferSourceACH$Outbound = {
  companyEntryDescription?: string | undefined;
  originatingCompanyName?: string | undefined;
  debitHoldPeriod?: string | undefined;
  secCode?: string | undefined;
  addenda?: Array<CreateTransferACHAddendaRecord$Outbound> | undefined;
};

/** @internal */
export const CreateTransferSourceACH$outboundSchema: z.ZodType<
  CreateTransferSourceACH$Outbound,
  z.ZodTypeDef,
  CreateTransferSourceACH
> = z.object({
  companyEntryDescription: z.string().optional(),
  originatingCompanyName: z.string().optional(),
  debitHoldPeriod: DebitHoldPeriod$outboundSchema.optional(),
  secCode: SECCode$outboundSchema.optional(),
  addenda: z.array(CreateTransferACHAddendaRecord$outboundSchema).optional(),
});

export function createTransferSourceACHToJSON(
  createTransferSourceACH: CreateTransferSourceACH,
): string {
  return JSON.stringify(
    CreateTransferSourceACH$outboundSchema.parse(createTransferSourceACH),
  );
}
export function createTransferSourceACHFromJSON(
  jsonString: string,
): SafeParseResult<CreateTransferSourceACH, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateTransferSourceACH$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateTransferSourceACH' from JSON`,
  );
}
